<wiz-hgroup width="100%" height="100%" class="section-container-parent" padding="5px">
  
  <!-- zone champs libres & filtre -->
   <wiz-vgroup width="240px" height="100%" style="padding-bottom: 2px;">
    <wiz-vgroup width="100%" height="100%" class="section-container">
      <wiz-label [wizLabel]="'$.pivot.edit.field.all.$'" class="smallTitleLabel"></wiz-label>
      <wiz-list
        #freeList
        id="freeList"
        height="100%"
        width="100%"
        [wizItemRenderer]="renderer"
        [wizDataProvider]="dataSource"
        [wizLabelField]="'fullCode'"
        [dragEnabled]="true"
      ></wiz-list>
      <filter-component #mainFilter> </filter-component>
    </wiz-vgroup>
   </wiz-vgroup>

  <!-- zone détail -->  
  <wiz-vgroup #vgDetailZone width="100%" height="100%" style="padding-bottom: 2px;">
    <!-- tryptique --> 
    <wiz-hgroup width="100%" height="100%">
      
      <!-- filtres & groupes d'entête -->  
      <wiz-vgroup width="240px" height="100%" style="padding-bottom: 2px;">
        <!-- champs filtres -->
        <wiz-vgroup width="100%" height="30%" class="section-container">
          <wiz-hgroup width="100%" class="widget-header" [verticalAlign]="'center'" padding="10px">
            <wiz-icon class="image-purple">icon-filters</wiz-icon>
            <wiz-label [wizLabel]="'$.pivot.edit.field.filter.$'" class="smallTitleLabel"></wiz-label>
          </wiz-hgroup>
          <wiz-list
            #lstFilter
            id="lstFilter"
            width="100%"
            height="100%"
            [wizLabelField]="'label'"
            [wizItemRenderer]="renderer"
            [dragEnabled]="true"
            [dropEnabled]="true"
            [enableSelfReorder]="true"
            [shopDropIndicator]="true"
            [dragMove]="true"
          ></wiz-list>
        </wiz-vgroup>

        <!-- groupes -->
        <wiz-vgroup width="100%" height="70%" class="section-container">
          <wiz-hgroup width="100%" class="widget-header" [verticalAlign]="'center'" padding="10px">
            <wiz-icon [wizTooltip]="'$.pivot.edit.field.groups.add.$'" class="image-back-orange" (click)="addGroup()">add</wiz-icon>
            <wiz-icon class="image-purple">icon-column</wiz-icon>
            <wiz-label [wizLabel]="'$.pivot.edit.field.groups.$'" class="smallTitleLabel"></wiz-label>
          </wiz-hgroup>
          <wiz-list
            #lstGroup
            id="lstGroup"
            width="100%"
            height="100%"
            [wizLabelField]="'label'"
            [wizItemRenderer]="groupRenderer"
            [dragEnabled]="true"
            [dropEnabled]="true"
            [enableSelfReorder]="true"
            [shopDropIndicator]="true"
          ></wiz-list>
        </wiz-vgroup>

      </wiz-vgroup><!-- fin filtres & groupes d'entête -->  

      <!-- champs en ligne, contrôles d'intégrité & params -->  
      <wiz-vgroup width="240px" height="100%" style="padding-bottom: 2px;">
      
        <!-- champs lignes -->
        <wiz-vgroup width="100%" height="100%" class="section-container">
          <wiz-hgroup width="100%" class="widget-header" [verticalAlign]="'center'" padding="10px">
            <wiz-icon class="image-purple">icon-line</wiz-icon>
            <wiz-label [wizLabel]="'$.pivot.edit.field.row.$'" class="smallTitleLabel"></wiz-label>
          </wiz-hgroup>
          <wiz-list
            #lstRow
            id="lstRow"
            width="100%"
            height="100%"
            [wizLabelField]="'label'"
            [wizItemRenderer]="renderer"
            [dragEnabled]="true"
            [dropEnabled]="true"
            [enableSelfReorder]="true"
            [shopDropIndicator]="true"
            [dragMove]="true"
          ></wiz-list>
          <!-- pour compatibilité avec mode Pivot -->
          <wiz-list
            #lstColumn
            id="lstColumn"
            [visible]="false"
            width="100%"
            height="100%"
            [wizLabelField]="'label'"
          ></wiz-list>
        </wiz-vgroup>
     
        <!-- zone contrôle d'intégrité -->
        <wiz-vgroup width="100%" height="220px" class="section-container">
          <wiz-hgroup width="100%" class="widget-header" [verticalAlign]="'center'" padding="10px">
            <wiz-icon class="image-purple">icon-formula</wiz-icon>
            <wiz-label [wizLabel]="'$.pivot.edit.field.integrity.$'" class="smallTitleLabel"></wiz-label>
          </wiz-hgroup>
          
          <wiz-checkbox #cbDeleteIntegrity [visible]="true" [wizLabel]="'$.pivot.edit.integrity.delete.$'"></wiz-checkbox>  
          <wiz-list
            #lstIntegrity
            id="lstDeleteCheck"
            width="100%"
            height="100%"
            [wizLabelField]="'label'"
            [wizItemRenderer]="renderer"
            [dragEnabled]="true"
            [dropEnabled]="true"
            [enableSelfReorder]="true"
            [shopDropIndicator]="true"
            [dragMove]="true"
          ></wiz-list>
          <wiz-checkbox #cbUpdateIntegrity [visible]="true" [wizLabel]="'$.pivot.edit.integrity.update.$'"></wiz-checkbox>
        </wiz-vgroup>
        
        <!-- suppressions & sélections -->
        <wiz-vgroup width="100%" [visible]="!isToolMode" class="section-container">
          <wiz-checkbox #cbShowDeleteCol [visible]="true" [wizLabel]="'$.pivot.edit.show.delete.$'"></wiz-checkbox>
          <wiz-checkbox #cbShowDeleteRecurseCol [visible]="true" [wizLabel]="'$.pivot.edit.show.delete.recurse.$'"></wiz-checkbox>
          <wiz-hgroup>
            <wiz-checkbox #cbShowSelectCol [wizLabel]="'$.pivot.edit.show.select.$'"></wiz-checkbox>
            <wiz-checkbox #cbSelectUnique [wizLabel]="'$.pivot.edit.select.unique.$'"></wiz-checkbox>
          </wiz-hgroup>
        </wiz-vgroup>

      </wiz-vgroup><!-- fin champs en ligne, contrôles d'intégrité & params -->  

      <!-- champs données -->  
      <wiz-vgroup width="100%" height="100%" style="padding-bottom: 2px;">
        
        <!-- champs datas -->
        <wiz-vgroup width="100%" height="100%" class="section-container">
          <wiz-hgroup width="100%" class="widget-header" [verticalAlign]="'center'" padding="10px">
            <wiz-icon class="image-purple">icon-formula</wiz-icon>
            <wiz-label [wizLabel]="'$.pivot.edit.field.data.$'" class="smallTitleLabel"></wiz-label>
          </wiz-hgroup>
          <wiz-list
            #lstData
            id="lstData"
            width="100%"
            height="100%"
            [wizLabelField]="'label'"
            [wizItemRenderer]="renderer"
            [dragEnabled]="true"
            [dropEnabled]="true"
            [enableSelfReorder]="true"
            [shopDropIndicator]="true"
            [dragMove]="true"
          ></wiz-list>
        </wiz-vgroup>

      </wiz-vgroup><!-- fin champs données -->  

    </wiz-hgroup><!-- fin tryptique --> 


    <!-- zone de validation --> 
    <wiz-hgroup width="100%" [horizontalAlign]="'end'" verticalAlign="center" class="section-container">
      <wiz-button
        #btnSave
        width="150px"
        (click)="doValid()"
        [wizLabel]="'$.common.save.modification.$'"
        [wizIcon]="'icon-arrow-right'"
        [iconPlacement]="'right'"
      ></wiz-button>
      <wiz-button
        #btnCancel
        width="150px"
        (click)="doCancel()"
        class="cancel-button"
        [wizIcon]="'icon-arrow-left'"
        [wizLabel]="'$.common.cancel.modification.$'"
      ></wiz-button>
    </wiz-hgroup>

  </wiz-vgroup>


</wiz-hgroup>
